// src/components/BusinessMetrics/BusinessMetrics.js
import React from 'react';
import './BusinessMetrics.css';

const BusinessMetrics = ({ sumOfSites, totalLines, lastWeekLines }) => {
  // Calculate difference for weekly feedback lines
  const calculateDifference = () => {
    if (!lastWeekLines) return 0;
    return (((totalLines - lastWeekLines) / lastWeekLines) * 100).toFixed(1);
  };
  
  const differenceWeeklyFeedbackLines = calculateDifference();
  
  // Calculate average responses per site
  const averageResponsesPerSite = Number(
    (parseInt(totalLines || 0) / Math.max(parseInt(sumOfSites || 0), 1)).toFixed(0)
  );

  // Determine trend color and icon
  const getTrendColor = () => {
    if (differenceWeeklyFeedbackLines > 0) return '#22c55e'; // Success green
    if (differenceWeeklyFeedbackLines < 0) return '#ef4444'; // Error red
    return '#64748b'; // Neutral gray
  };

  const getTrendIcon = () => {
    if (differenceWeeklyFeedbackLines > 0) return '↗';
    if (differenceWeeklyFeedbackLines < 0) return '↘';
    return '→';
  };

  return (
    <div className="metrics-row">
      <div className="metric-card">
        <div className="metric-header">
          <h4 className="metric-title">Operational Deployments</h4>
        </div>
        <div className="metric-content">
          <div className="metric-value primary">{sumOfSites || 0}</div>
          <div className="metric-subtitle">Active sites</div>
        </div>
      </div>
      
      <div className="metric-card">
        <div className="metric-header">
          <h4 className="metric-title">Feedback Past Week</h4>
        </div>
        <div className="metric-content">
          <div className="metric-value primary">{totalLines || 0}</div>
          {differenceWeeklyFeedbackLines !== 0 && (
            <div className="metric-trend" style={{ color: getTrendColor() }}>
              <span className="trend-icon">{getTrendIcon()}</span>
              <span className="trend-percentage">{Math.abs(differenceWeeklyFeedbackLines)}%</span>
              <span className="trend-text">vs last week</span>
            </div>
          )}
          {differenceWeeklyFeedbackLines == 0 && (
            <div className="metric-subtitle">Total responses</div>
          )}
        </div>
      </div>
      
      <div className="metric-card">
        <div className="metric-header">
          <h4 className="metric-title">Average Responses per Site</h4>
        </div>
        <div className="metric-content">
          <div className="metric-value primary">{averageResponsesPerSite}</div>
          <div className="metric-subtitle">Per site average</div>
        </div>
      </div>
    </div>
  );
};

export default BusinessMetrics;